// // // pages/assessment/MyAssessments.jsx
// // import { useState, useEffect } from "react";
// // import { useNavigate } from "react-router-dom";
// // import axios from "axios";
// // import {
// //   Box,
// //   Typography,
// //   Card,
// //   CardContent,
// //   CardActions,
// //   Button,
// //   CircularProgress,
// //   Alert,
// //   Chip,
// //   Grid,
// // } from "@mui/material";
// // import { useATS } from "../atsModule/context/ATSContext";

// // const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

// // const MyAssessments = () => {
// //   const navigate = useNavigate();
// //   const { store_id, user_id } = useATS();
// //   const [assignments, setAssignments] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState("");

// //   useEffect(() => {
// //     const fetchAssignments = async () => {
// //       if (!user_id) return;
// //       try {
// //         setLoading(true);
// //         const res = await axios.get(
// //           `${API_BASE}/api/assessment/my-assessments`,
// //           {
// //             params: { store_id, user_id },
// //           },
// //         );
// //         console.log("Assignments response:", res.data.data);
// //         setAssignments(res.data.data || []);
// //         setError("");
// //       } catch (err) {
// //         console.error(err);
// //         setError("Failed to load your assessments");
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     fetchAssignments();
// //   }, [store_id, user_id]);

// //   if (loading)
// //     return <CircularProgress sx={{ display: "block", mx: "auto", mt: 4 }} />;
// //   if (error) return <Alert severity="error">{error}</Alert>;

// //   return (
// //     <Box>
// //       <Typography variant="h4" fontWeight={600} gutterBottom>
// //         My Assessments
// //       </Typography>
// //       {assignments.length === 0 ? (
// //         <Alert severity="info">You have no assigned assessments yet.</Alert>
// //       ) : (
// //         <Grid container spacing={3}>
// //           {assignments.map((ass) => {
// //             // Use lowercase 'assessment' as returned by API
// //             const assessment = ass.assessment || {};
// //             return (
// //               <Grid item xs={12} sm={6} md={4} key={ass.id}>
// //                 <Card>
// //                   <CardContent>
// //                     <Typography variant="h6">
// //                       {assessment.title || "Untitled"}
// //                     </Typography>
// //                     <Typography
// //                       variant="body2"
// //                       color="text.secondary"
// //                       sx={{ mt: 1 }}
// //                     >
// //                       {assessment.description || "No description"}
// //                     </Typography>
// //                     <Typography
// //                       variant="caption"
// //                       display="block"
// //                       sx={{ mt: 1 }}
// //                     >
// //                       Max Score: {assessment.max_score ?? "N/A"}
// //                     </Typography>
// //                     <Typography variant="caption" display="block">
// //                       Passing Score: {assessment.passing_score ?? "N/A"}
// //                     </Typography>
// //                     <Chip
// //                       label={ass.status}
// //                       color={ass.status === "COMPLETED" ? "success" : "warning"}
// //                       size="small"
// //                       sx={{ mt: 1 }}
// //                     />
// //                     {ass.status === "COMPLETED" && (
// //                       <Typography variant="body2" sx={{ mt: 1 }}>
// //                         Your Score: {ass.score} /{" "}
// //                         {assessment.max_score || "N/A"}
// //                       </Typography>
// //                     )}
// //                   </CardContent>
// //                   <CardActions>
// //                     {ass.status !== "COMPLETED" && (
// //                       <Button
// //                         size="small"
// //                         variant="contained"
// //                         onClick={() =>
// //                           navigate(`/ats/assessments/take/${ass.id}`)
// //                         }
// //                         sx={{ bgcolor: "#1a2a3a" }}
// //                       >
// //                         Take Assessment
// //                       </Button>
// //                     )}
// //                   </CardActions>
// //                 </Card>
// //               </Grid>
// //             );
// //           })}
// //         </Grid>
// //       )}
// //     </Box>
// //   );
// // };

// // export default MyAssessments;
// // pages/assessment/MyAssessments.jsx

// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   Box,
//   Typography,
//   Card,
//   CardContent,
//   CardActions,
//   Button,
//   CircularProgress,
//   Alert,
//   Chip,
//   Grid,
//   Skeleton,
//   Tooltip,
// } from "@mui/material";
// import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
// import SchoolIcon from "@mui/icons-material/School";
// import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
// import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
// import { useATS } from "../atsModule/context/ATSContext";

// const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

// // Blue palette (consistent with other components)
// const BLUE = {
//   50: "#eff6ff",
//   100: "#dbeafe",
//   200: "#bfdbfe",
//   300: "#93c5fd",
//   400: "#60a5fa",
//   500: "#3b82f6",
//   600: "#2563eb",
//   700: "#1d4ed8",
//   900: "#1e3a8a",
// };

// // Keyframes injection
// const KF_ID = "fa-keyframes-my-assessments";
// if (typeof document !== "undefined" && !document.getElementById(KF_ID)) {
//   const style = document.createElement("style");
//   style.id = KF_ID;
//   style.textContent = `
//     @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
//     @keyframes fadeUp { from{opacity:0;transform:translateY(22px)} to{opacity:1;transform:translateY(0)} }
//     @keyframes float   { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-7px)} }
//   `;
//   document.head.appendChild(style);
// }

// const fontFam = "'Plus Jakarta Sans', sans-serif";

// const primaryBtnSx = {
//   background: `linear-gradient(135deg, ${BLUE[600]} 0%, ${BLUE[700]} 100%)`,
//   color: "#fff",
//   borderRadius: "11px",
//   px: 2,
//   py: 0.8,
//   fontFamily: fontFam,
//   fontWeight: 600,
//   boxShadow: `0 4px 14px ${BLUE[200]}`,
//   "&:hover": {
//     transform: "translateY(-2px)",
//     boxShadow: `0 8px 22px ${BLUE[300]}`,
//     background: `linear-gradient(135deg, ${BLUE[700]} 0%, ${BLUE[900]} 100%)`,
//   },
//   transition: "all 0.2s ease",
// };

// // Shared card accent colors (matching assessment cards)
// const CARD_ACCENTS = [
//   {
//     border: "#2563eb",
//     glow: "rgba(37,99,235,.12)",
//     bg: "#eff6ff",
//     icon: "#2563eb",
//   },
//   {
//     border: "#7c3aed",
//     glow: "rgba(124,58,237,.12)",
//     bg: "#f5f3ff",
//     icon: "#7c3aed",
//   },
//   {
//     border: "#0891b2",
//     glow: "rgba(8,145,178,.12)",
//     bg: "#ecfeff",
//     icon: "#0891b2",
//   },
//   {
//     border: "#16a34a",
//     glow: "rgba(22,163,74,.12)",
//     bg: "#f0fdf4",
//     icon: "#16a34a",
//   },
//   {
//     border: "#ea580c",
//     glow: "rgba(234,88,12,.12)",
//     bg: "#fff7ed",
//     icon: "#ea580c",
//   },
//   {
//     border: "#db2777",
//     glow: "rgba(219,39,119,.12)",
//     bg: "#fdf2f8",
//     icon: "#db2777",
//   },
// ];

// const SkeletonCard = () => (
//   <Card
//     sx={{
//       borderRadius: "20px",
//       boxShadow: "0 4px 20px rgba(0,0,0,.05)",
//       background: "#fff",
//     }}
//   >
//     <CardContent sx={{ p: 2.5 }}>
//       <Skeleton
//         variant="rounded"
//         width={48}
//         height={48}
//         sx={{ borderRadius: "12px", mb: 2 }}
//       />
//       <Skeleton variant="text" width="70%" height={26} />
//       <Skeleton variant="text" width="90%" height={18} sx={{ mt: 1 }} />
//       <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
//         <Skeleton
//           variant="rounded"
//           width={70}
//           height={22}
//           sx={{ borderRadius: "8px" }}
//         />
//         <Skeleton
//           variant="rounded"
//           width={70}
//           height={22}
//           sx={{ borderRadius: "8px" }}
//         />
//       </Box>
//     </CardContent>
//     <CardActions sx={{ px: 2.5, pb: 2 }}>
//       <Skeleton
//         variant="rounded"
//         width={110}
//         height={32}
//         sx={{ borderRadius: "8px" }}
//       />
//     </CardActions>
//   </Card>
// );

// const EmptyState = () => (
//   <Box
//     sx={{
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       py: 12,
//       gap: 2,
//       animation: "fadeUp 0.5s ease both",
//     }}
//   >
//     <Box
//       sx={{
//         width: 88,
//         height: 88,
//         borderRadius: "50%",
//         background: `linear-gradient(135deg, ${BLUE[100]} 0%, ${BLUE[200]} 100%)`,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         animation: "float 3s ease-in-out infinite",
//         boxShadow: `0 8px 24px ${BLUE[200]}`,
//       }}
//     >
//       <SchoolIcon sx={{ fontSize: 42, color: BLUE[600] }} />
//     </Box>
//     <Typography
//       variant="h6"
//       fontWeight={700}
//       color="#0f172a"
//       fontFamily={fontFam}
//     >
//       No assessments assigned
//     </Typography>
//     <Typography
//       variant="body2"
//       color="text.secondary"
//       textAlign="center"
//       fontFamily={fontFam}
//     >
//       You don't have any pending or completed assessments yet.
//     </Typography>
//   </Box>
// );

// const MyAssessments = () => {
//   const navigate = useNavigate();
//   const { store_id, user_id } = useATS();
//   const [assignments, setAssignments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchAssignments = async () => {
//       if (!user_id) return;
//       try {
//         setLoading(true);
//         const res = await axios.get(
//           `${API_BASE}/api/assessment/my-assessments`,
//           {
//             params: { store_id, user_id },
//           },
//         );
//         console.log("Assignments response:", res.data.data);
//         setAssignments(res.data.data || []);
//         setError("");
//       } catch (err) {
//         console.error(err);
//         setError("Failed to load your assessments");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchAssignments();
//   }, [store_id, user_id]);

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           minHeight: "100vh",
//           background: "#f8fafc",
//           fontFamily: fontFam,
//           p: { xs: 2, sm: 4 },
//         }}
//       >
//         <Skeleton variant="rounded" width="40%" height={42} sx={{ mb: 2 }} />
//         <Skeleton variant="rounded" width="60%" height={24} sx={{ mb: 4 }} />
//         <Grid container spacing={3}>
//           {[...Array(3)].map((_, i) => (
//             <Grid item xs={12} sm={6} md={4} key={i}>
//               <SkeletonCard />
//             </Grid>
//           ))}
//         </Grid>
//       </Box>
//     );
//   }
//   if (error)
//     return (
//       <Alert severity="error" sx={{ m: 3 }}>
//         {error}
//       </Alert>
//     );

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         background: "#f8fafc",
//         fontFamily: fontFam,
//         p: { xs: 2, sm: 4 },
//       }}
//     >
//       {/* Quote Banner */}
//       <Box
//         sx={{
//           mb: 4,
//           p: "13px 20px",
//           borderRadius: "14px",
//           background: "#0c8a9b",
//           display: "flex",
//           alignItems: "center",
//           gap: 1.5,
//           animation: "fadeUp 0.4s ease both",
//           boxShadow: `0 4px 18px #0c8a9b`,
//         }}
//       >
//         <AutoAwesomeIcon
//           sx={{ color: "#fde68a", fontSize: 18, flexShrink: 0 }}
//         />
//         <Typography
//           sx={{
//             color: "#fff",
//             fontSize: "0.82rem",
//             fontWeight: 500,
//             fontStyle: "italic",
//             fontFamily: fontFam,
//           }}
//         >
//           "Assessment is the bridge between teaching and learning."{" "}
//         </Typography>
//       </Box>

//       {/* Header */}
//       <Box sx={{ mb: 4, animation: "fadeUp 0.45s ease both" }}>
//         <Typography
//           variant="h4"
//           sx={{
//             fontWeight: 800,
//             fontFamily: fontFam,
//             color: "#0f172a",
//             letterSpacing: "-0.5px",
//           }}
//         >
//           My Assessments
//         </Typography>
//         <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
//           {assignments.length} assessment{assignments.length !== 1 ? "s" : ""}{" "}
//           assigned to you
//         </Typography>
//       </Box>

//       {assignments.length === 0 ? (
//         <EmptyState />
//       ) : (
//         <Grid container spacing={3}>
//           {assignments.map((ass, idx) => {
//             const assessment = ass.assessment || {};
//             const accent = CARD_ACCENTS[idx % CARD_ACCENTS.length];
//             const delay = `${idx * 0.06}s`;
//             const isCompleted = ass.status === "COMPLETED";
//             const passingScore = assessment.passing_score || 0;
//             const obtainedScore = ass.score || 0;
//             const passed = obtainedScore >= passingScore;

//             return (
//               <Grid item xs={12} sm={6} md={4} key={ass.id}>
//                 <Card
//                   sx={{
//                     borderRadius: "20px",
//                     background: "#fff",
//                     height: "100%",
//                     display: "flex",
//                     flexDirection: "column",
//                     boxShadow:
//                       "0 4px 20px rgba(0,0,0,.05), 0 1px 3px rgba(0,0,0,.04)",
//                     border: `1px solid ${accent.border}20`,
//                     animation: `fadeUp 0.5s ease ${delay} both`,
//                     transition: "all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)",
//                     "&:hover": {
//                       transform: "scale(1.02) translateY(-4px)",
//                       boxShadow: `0 16px 40px ${accent.glow}, 0 4px 12px rgba(0,0,0,.06)`,
//                       borderColor: accent.border + "80",
//                     },
//                   }}
//                 >
//                   <CardContent sx={{ p: 2.5, flex: 1 }}>
//                     <Box
//                       sx={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "flex-start",
//                         mb: 2,
//                       }}
//                     >
//                       <Box
//                         sx={{
//                           width: 48,
//                           height: 48,
//                           borderRadius: "14px",
//                           background: accent.bg,
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           transition: "transform 0.25s ease",
//                           "&:hover": { transform: "rotate(-4deg) scale(1.05)" },
//                         }}
//                       >
//                         <SchoolIcon sx={{ fontSize: 26, color: accent.icon }} />
//                       </Box>
//                       <Chip
//                         label={ass.status}
//                         size="small"
//                         sx={{
//                           fontFamily: fontFam,
//                           fontWeight: 600,
//                           fontSize: "0.7rem",
//                           backgroundColor: isCompleted ? "#f0fdf4" : "#fffbeb",
//                           color: isCompleted ? "#16a34a" : "#d97706",
//                           borderRadius: "8px",
//                         }}
//                       />
//                     </Box>
//                     <Typography
//                       variant="h6"
//                       sx={{
//                         fontWeight: 700,
//                         fontFamily: fontFam,
//                         color: "#0f172a",
//                         mb: 0.5,
//                         lineHeight: 1.3,
//                       }}
//                     >
//                       {assessment.title || "Untitled Assessment"}
//                     </Typography>
//                     {assessment.description && (
//                       <Typography
//                         variant="body2"
//                         sx={{
//                           color: "#64748b",
//                           lineHeight: 1.5,
//                           mb: 2,
//                           display: "-webkit-box",
//                           WebkitLineClamp: 2,
//                           WebkitBoxOrient: "vertical",
//                           overflow: "hidden",
//                         }}
//                       >
//                         {assessment.description}
//                       </Typography>
//                     )}
//                     <Box
//                       sx={{ display: "flex", gap: 2, mt: 2, flexWrap: "wrap" }}
//                     >
//                       <Tooltip title="Maximum possible score">
//                         <Box
//                           sx={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 0.5,
//                           }}
//                         >
//                           <EmojiEventsOutlinedIcon
//                             sx={{ fontSize: 15, color: "#94a3b8" }}
//                           />
//                           <Typography
//                             sx={{
//                               fontSize: "0.75rem",
//                               color: "#64748b",
//                               fontFamily: fontFam,
//                             }}
//                           >
//                             Max:{" "}
//                             <strong style={{ color: "#0f172a" }}>
//                               {assessment.max_score ?? "N/A"}
//                             </strong>
//                           </Typography>
//                         </Box>
//                       </Tooltip>
//                       <Tooltip title="Minimum passing score">
//                         <Box
//                           sx={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 0.5,
//                           }}
//                         >
//                           <CheckCircleOutlineIcon
//                             sx={{ fontSize: 15, color: "#94a3b8" }}
//                           />
//                           <Typography
//                             sx={{
//                               fontSize: "0.75rem",
//                               color: "#64748b",
//                               fontFamily: fontFam,
//                             }}
//                           >
//                             Pass:{" "}
//                             <strong style={{ color: "#0f172a" }}>
//                               {assessment.passing_score ?? "N/A"}
//                             </strong>
//                           </Typography>
//                         </Box>
//                       </Tooltip>
//                       {assessment.duration_minutes && (
//                         <Tooltip title="Time limit (minutes)">
//                           <Box
//                             sx={{
//                               display: "flex",
//                               alignItems: "center",
//                               gap: 0.5,
//                             }}
//                           >
//                             <TimerOutlinedIcon
//                               sx={{ fontSize: 15, color: "#94a3b8" }}
//                             />
//                             <Typography
//                               sx={{
//                                 fontSize: "0.75rem",
//                                 color: "#64748b",
//                                 fontFamily: fontFam,
//                               }}
//                             >
//                               <strong style={{ color: "#0f172a" }}>
//                                 {assessment.duration_minutes}
//                               </strong>{" "}
//                               min
//                             </Typography>
//                           </Box>
//                         </Tooltip>
//                       )}
//                     </Box>
//                     {isCompleted && (
//                       <Box
//                         sx={{
//                           mt: 2,
//                           p: 1,
//                           borderRadius: "12px",
//                           background: passed ? "#f0fdf4" : "#fef2f2",
//                           border: `1px solid ${passed ? "#bbf7d0" : "#fecaca"}`,
//                           textAlign: "center",
//                         }}
//                       >
//                         <Typography
//                           variant="body2"
//                           fontFamily={fontFam}
//                           fontWeight={600}
//                           color={passed ? "#16a34a" : "#dc2626"}
//                         >
//                           Score: {ass.score} / {assessment.max_score}
//                         </Typography>
//                         <Typography
//                           variant="caption"
//                           fontFamily={fontFam}
//                           color={passed ? "#166534" : "#991b1b"}
//                         >
//                           {passed ? "✓ Passed" : "✗ Failed"}
//                         </Typography>
//                       </Box>
//                     )}
//                   </CardContent>
//                   <CardActions>
//                     {!isCompleted ? (
//                       <Button
//                         size="small"
//                         variant="contained"
//                         onClick={() =>
//                           navigate(`/ats/assessments/take/${ass.id}`)
//                         }
//                       >
//                         Take Assessment
//                       </Button>
//                     ) : (
//                       <Button
//                         size="small"
//                         variant="outlined"
//                         onClick={() =>
//                           navigate(`/ats/assessments/results/${ass.id}`)
//                         }
//                       >
//                         View Results
//                       </Button>
//                     )}
//                   </CardActions>
//                 </Card>
//               </Grid>
//             );
//           })}
//         </Grid>
//       )}
//     </Box>
//   );
// };

// export default MyAssessments;import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Chip,
  Grid,
  Skeleton,
  Alert,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
} from "@mui/material";

import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { useATS } from "../atsModule/context/ATSContext";
import { useState, useEffect } from "react";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

const FONT = "'DM Sans', 'Inter', sans-serif";

const PRIMARY = "#0A8AA0";
const BG = "#F5F7FB";
const CARD = "#FFFFFF";
const TEXT = "#101828";
const MUTED = "#667085";
const BORDER = "#E9EEF5";

const KF_ID = "assessment-ui-kf";

if (typeof document !== "undefined" && !document.getElementById(KF_ID)) {
  const style = document.createElement("style");
  style.id = KF_ID;

  style.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700;800&display=swap');

    @keyframes fadeUp {
      from {
        opacity: 0;
        transform: translateY(14px);
      }
      to {
        opacity: 1;
        transform: translateY(0px);
      }
    }
  `;

  document.head.appendChild(style);
}

const STATUS_STYLE = {
  COMPLETED: {
    label: "Completed",
    bg: "#ECFDF3",
    color: "#039855",
  },
  IN_PROGRESS: {
    label: "In Progress",
    bg: "#FFF7ED",
    color: "#EA580C",
  },
  PENDING: {
    label: "Not Started",
    bg: "#F2F4F7",
    color: "#667085",
  },
};

const StatCard = ({ icon, title, value, bg }) => {
  return (
    <Box
      sx={{
        background: CARD,
        border: `1px solid ${BORDER}`,
        borderRadius: "18px",
        px: 2.2,
        py: 1.7,
        minWidth: 155,
        display: "flex",
        alignItems: "center",
        gap: 1.6,
        boxShadow: "0px 2px 10px rgba(16,24,40,0.04)",
      }}
    >
      <Box
        sx={{
          width: 46,
          height: 46,
          borderRadius: "14px",
          background: bg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {icon}
      </Box>

      <Box>
        <Typography
          sx={{
            fontFamily: FONT,
            fontSize: "0.7rem",
            fontWeight: 700,
            color: "#98A2B3",
            textTransform: "uppercase",
            letterSpacing: "0.08em",
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            fontFamily: FONT,
            fontWeight: 800,
            color: TEXT,
            fontSize: "1.6rem",
            lineHeight: 1,
            mt: 0.3,
          }}
        >
          {String(value).padStart(2, "0")}
        </Typography>
      </Box>
    </Box>
  );
};

const SkeletonCard = () => (
  <Card
    sx={{
      borderRadius: "22px",
      border: `1px solid ${BORDER}`,
      boxShadow: "0px 3px 12px rgba(16,24,40,0.04)",
      background: "#fff",
    }}
  >
    <CardContent sx={{ p: 2.5 }}>
      <Skeleton
        variant="rounded"
        width={48}
        height={48}
        sx={{ borderRadius: "14px", mb: 2 }}
      />

      <Skeleton width="75%" height={28} />
      <Skeleton width="45%" height={18} />

      <Skeleton
        variant="rounded"
        height={7}
        sx={{
          mt: 3,
          borderRadius: "999px",
        }}
      />

      <Skeleton
        variant="rounded"
        width={120}
        height={40}
        sx={{
          borderRadius: "999px",
          mt: 3,
        }}
      />
    </CardContent>
  </Card>
);

const MyAssessments = () => {
  const navigate = useNavigate();

  const { store_id, user_id } = useATS();

  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchAssignments = async () => {
      if (!user_id) return;

      try {
        setLoading(true);

        const res = await axios.get(
          `${API_BASE}/api/assessment/my-assessments`,
          {
            params: {
              store_id,
              user_id,
            },
          },
        );

        setAssignments(res.data.data || []);
        setError("");
      } catch (err) {
        console.error(err);
        setError("Failed to load your assessments");
      } finally {
        setLoading(false);
      }
    };

    fetchAssignments();
  }, [store_id, user_id]);

  const activeAssignments = assignments.filter((a) => a.status !== "COMPLETED");

  const completedAssignments = assignments.filter(
    (a) => a.status === "COMPLETED",
  );

  const pendingCount = assignments.filter((a) => a.status === "PENDING").length;

  const completedCount = completedAssignments.length;

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "80vh",
          borderRadius: 0.4,
          background: BG,
          p: { xs: 2, md: 4 },
          fontFamily: FONT,
        }}
      >
        <Skeleton width={280} height={44} />
        <Skeleton width={500} height={24} sx={{ mb: 4 }} />

        <Grid container spacing={3}>
          {[1, 2, 3].map((item) => (
            <Grid item xs={12} md={4} key={item}>
              <SkeletonCard />
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ m: 3 }}>
        {error}
      </Alert>
    );
  }

  return (
    <Box
      sx={{
        minHeight: "80vh",
        borderRadius: 0.4,
        background: BG,
        p: { xs: 2, sm: 3, md: 4 },
        fontFamily: FONT,
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 3,
          mb: 4,
          flexWrap: "wrap",
          animation: "fadeUp .45s ease both",
        }}
      >
        <Box>
          <Typography
            sx={{
              fontFamily: FONT,
              fontWeight: 800,
              fontSize: {
                xs: "2rem",
                md: "2.4rem",
              },
              color: TEXT,
              letterSpacing: "-0.03em",
            }}
          >
            My Assessments
          </Typography>

          <Typography
            sx={{
              fontFamily: FONT,
              color: MUTED,
              mt: 0.7,
              fontSize: "0.96rem",
              maxWidth: 650,
              lineHeight: 1.7,
            }}
          >
            Keep track of your evaluation assignments. Quality assessments lead
            to better hiring decisions.
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <StatCard
            title="Pending"
            value={pendingCount}
            bg="#E0F2FE"
            icon={
              <PendingOutlinedIcon
                sx={{
                  color: PRIMARY,
                  fontSize: 24,
                }}
              />
            }
          />

          <StatCard
            title="Completed"
            value={completedCount}
            bg="#ECFDF3"
            icon={
              <CheckCircleOutlineIcon
                sx={{
                  color: "#039855",
                  fontSize: 24,
                }}
              />
            }
          />
        </Box>
      </Box>

      {/* ACTIVE ASSIGNMENTS */}
      {activeAssignments.length > 0 && (
        <Box
          sx={{
            mb: 5,
            animation: "fadeUp .5s ease both",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2.5,
            }}
          >
            <Typography
              sx={{
                fontFamily: FONT,
                fontWeight: 800,
                fontSize: "1.25rem",
                color: TEXT,
              }}
            >
              Active Assignments
            </Typography>

            <Button
              endIcon={<ArrowForwardIcon />}
              sx={{
                textTransform: "none",
                color: PRIMARY,
                fontFamily: FONT,
                fontWeight: 700,
                fontSize: "0.88rem",
              }}
            >
              View Priority List
            </Button>
          </Box>

          <Grid container spacing={3}>
            {activeAssignments.map((ass, idx) => {
              const assessment = ass.assessment || {};

              const st = STATUS_STYLE[ass.status] || STATUS_STYLE.PENDING;

              const isInProgress = ass.status === "IN_PROGRESS";

              return (
                <Grid item xs={12} md={4} key={ass.id}>
                  <Card
                    sx={{
                      borderRadius: "24px",
                      border: `1px solid ${BORDER}`,
                      background: CARD,
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      boxShadow: "0px 4px 18px rgba(16,24,40,0.05)",
                      transition: "all .25s ease",
                      animation: `fadeUp .45s ease ${idx * 0.08}s both`,
                      "&:hover": {
                        transform: "translateY(-4px)",
                        boxShadow: "0px 10px 24px rgba(16,24,40,0.08)",
                      },
                    }}
                  >
                    <CardContent
                      sx={{
                        p: 3,
                        pb: 2,
                      }}
                    >
                      {/* TOP */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          mb: 2.2,
                        }}
                      >
                        <Box
                          sx={{
                            width: 50,
                            height: 50,
                            borderRadius: "16px",
                            background: "#E8F7FA",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <SchoolOutlinedIcon
                            sx={{
                              color: PRIMARY,
                              fontSize: 24,
                            }}
                          />
                        </Box>

                        <Chip
                          label={st.label}
                          size="small"
                          sx={{
                            background: st.bg,
                            color: st.color,
                            fontWeight: 700,
                            fontFamily: FONT,
                            borderRadius: "999px",
                            fontSize: "0.72rem",
                          }}
                        />
                      </Box>

                      {/* TITLE */}
                      <Typography
                        sx={{
                          fontFamily: FONT,
                          fontWeight: 800,
                          fontSize: "1.22rem",
                          color: TEXT,
                          lineHeight: 1.35,
                          mb: 0.8,
                        }}
                      >
                        {assessment.title || "Untitled Assessment"}
                      </Typography>

                      {/* DESCRIPTION */}
                      <Typography
                        sx={{
                          fontFamily: FONT,
                          fontSize: "0.9rem",
                          color: MUTED,
                          lineHeight: 1.6,
                          minHeight: 44,
                          mb: 2.5,
                        }}
                      >
                        {assessment.description ||
                          "Assessment description unavailable"}
                      </Typography>

                      {/* STATS */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1.2,
                          mb: 2.5,
                        }}
                      >
                        {assessment.duration_minutes && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <TimerOutlinedIcon
                              sx={{
                                color: "#98A2B3",
                                fontSize: 18,
                              }}
                            />

                            <Typography
                              sx={{
                                fontFamily: FONT,
                                fontSize: "0.84rem",
                                color: MUTED,
                                fontWeight: 500,
                              }}
                            >
                              Est. time: {assessment.duration_minutes} mins
                            </Typography>
                          </Box>
                        )}

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <EmojiEventsOutlinedIcon
                            sx={{
                              color: "#98A2B3",
                              fontSize: 18,
                            }}
                          />

                          <Typography
                            sx={{
                              fontFamily: FONT,
                              fontSize: "0.84rem",
                              color: MUTED,
                              fontWeight: 500,
                            }}
                          >
                            Max Score: {assessment.max_score ?? "N/A"}
                          </Typography>
                        </Box>
                      </Box>

                      {/* PROGRESS */}
                      {isInProgress && (
                        <Box sx={{ mb: 2 }}>
                          <LinearProgress
                            variant="determinate"
                            value={65}
                            sx={{
                              height: 7,
                              borderRadius: "999px",
                              background: "#EAECF0",
                              "& .MuiLinearProgress-bar": {
                                background: PRIMARY,
                                borderRadius: "999px",
                              },
                            }}
                          />

                          <Typography
                            sx={{
                              fontFamily: FONT,
                              color: MUTED,
                              fontSize: "0.78rem",
                              mt: 1,
                              fontWeight: 600,
                            }}
                          >
                            65% Completed
                          </Typography>
                        </Box>
                      )}
                    </CardContent>

                    {/* ACTION */}
                    <Box
                      sx={{
                        px: 3,
                        pb: 3,
                      }}
                    >
                      <Button
                        fullWidth
                        onClick={() =>
                          navigate(`/ats/assessments/take/${ass.id}`)
                        }
                        variant="contained"
                        sx={{
                          background: PRIMARY,
                          borderRadius: "999px",
                          py: 1.2,
                          textTransform: "none",
                          fontFamily: FONT,
                          fontWeight: 700,
                          fontSize: "0.95rem",
                          boxShadow: "none",
                          "&:hover": {
                            background: "#087B8E",
                            boxShadow: "none",
                          },
                        }}
                      >
                        {isInProgress ? "Resume" : "Take Assessment"}
                      </Button>
                    </Box>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      )}

      {/* EMPTY */}
      {!loading && assignments.length === 0 && (
        <Box
          sx={{
            textAlign: "center",
            py: 10,
          }}
        >
          <Avatar
            sx={{
              width: 82,
              height: 82,
              mx: "auto",
              mb: 2,
              background: "#E8F7FA",
            }}
          >
            <SchoolOutlinedIcon
              sx={{
                color: PRIMARY,
                fontSize: 36,
              }}
            />
          </Avatar>

          <Typography
            sx={{
              fontFamily: FONT,
              fontWeight: 800,
              fontSize: "1.3rem",
              color: TEXT,
            }}
          >
            No assessments assigned
          </Typography>

          <Typography
            sx={{
              fontFamily: FONT,
              color: MUTED,
              mt: 1,
            }}
          >
            You don't have any pending or completed assessments yet.
          </Typography>
        </Box>
      )}

      {/* BOTTOM SECTION */}
      {completedAssignments.length > 0 && (
        <Grid container spacing={3}>
          {/* PERFORMANCE CARD */}
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                borderRadius: "24px",
                border: `1px solid ${BORDER}`,
                background: CARD,
                boxShadow: "0px 4px 18px rgba(16,24,40,0.05)",
                height: "100%",
                animation: "fadeUp .55s ease both",
              }}
            >
              <CardContent sx={{ p: 3 }}>
                <Typography
                  sx={{
                    fontFamily: FONT,
                    fontWeight: 800,
                    color: TEXT,
                    fontSize: "1.08rem",
                    mb: 3,
                  }}
                >
                  Recent Results
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mb: 3,
                  }}
                >
                  <Box
                    sx={{
                      width: 130,
                      height: 130,
                      borderRadius: "50%",
                      border: "10px solid #D9F2F6",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        inset: -10,
                        borderRadius: "50%",
                        borderTop: `10px solid ${PRIMARY}`,
                        borderRight: `10px solid ${PRIMARY}`,
                        borderBottom: `10px solid ${PRIMARY}`,
                        borderLeft: "10px solid transparent",
                        transform: "rotate(45deg)",
                      }}
                    />

                    <Typography
                      sx={{
                        fontFamily: FONT,
                        fontWeight: 800,
                        fontSize: "2rem",
                        color: PRIMARY,
                      }}
                    >
                      88%
                    </Typography>
                  </Box>
                </Box>

                {[
                  {
                    label: "Accuracy",
                    value: "92%",
                  },
                  {
                    label: "Completion Rate",
                    value: "100%",
                  },
                  {
                    label: "Avg. Time Taken",
                    value: "32m",
                  },
                ].map((item) => (
                  <Box
                    key={item.label}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      py: 1.5,
                      borderBottom: `1px solid ${BORDER}`,
                      "&:last-child": {
                        borderBottom: "none",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: FONT,
                        color: MUTED,
                        fontSize: "0.9rem",
                        fontWeight: 600,
                      }}
                    >
                      {item.label}
                    </Typography>

                    <Typography
                      sx={{
                        fontFamily: FONT,
                        color: TEXT,
                        fontSize: "0.92rem",
                        fontWeight: 800,
                      }}
                    >
                      {item.value}
                    </Typography>
                  </Box>
                ))}
              </CardContent>
            </Card>
          </Grid>

          {/* COMPLETED TABLE */}
          <Grid item xs={12} md={8}>
            <Card
              sx={{
                borderRadius: "24px",
                border: `1px solid ${BORDER}`,
                boxShadow: "0px 4px 18px rgba(16,24,40,0.05)",
                overflow: "hidden",
                animation: "fadeUp .6s ease both",
              }}
            >
              <Box
                sx={{
                  px: 3,
                  py: 2.5,
                  borderBottom: `1px solid ${BORDER}`,
                }}
              >
                <Typography
                  sx={{
                    fontFamily: FONT,
                    fontWeight: 800,
                    fontSize: "1.1rem",
                    color: TEXT,
                  }}
                >
                  Completed Assessments
                </Typography>
              </Box>

              <TableContainer component={Paper} elevation={0}>
                <Table>
                  <TableHead>
                    <TableRow
                      sx={{
                        background: "#F9FAFB",
                      }}
                    >
                      {["Title", "Date", "Score", "Action"].map((head) => (
                        <TableCell
                          key={head}
                          sx={{
                            borderBottom: `1px solid ${BORDER}`,
                            fontFamily: FONT,
                            fontWeight: 800,
                            color: "#98A2B3",
                            fontSize: "0.72rem",
                            textTransform: "uppercase",
                            letterSpacing: "0.08em",
                            py: 2,
                          }}
                        >
                          {head}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {completedAssignments.map((ass, idx) => {
                      const assessment = ass.assessment || {};

                      const passed =
                        (ass.score || 0) >= (assessment.passing_score || 0);

                      return (
                        <TableRow
                          key={ass.id}
                          sx={{
                            transition: "0.2s ease",
                            animation: `fadeUp .45s ease ${idx * 0.05}s both`,
                            "&:hover": {
                              background: "#FCFCFD",
                            },
                          }}
                        >
                          <TableCell
                            sx={{
                              borderBottom: `1px solid ${BORDER}`,
                              py: 2.2,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1.6,
                              }}
                            >
                              <Box
                                sx={{
                                  width: 42,
                                  height: 42,
                                  borderRadius: "14px",
                                  background: "#E8F7FA",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  flexShrink: 0,
                                }}
                              >
                                <BarChartOutlinedIcon
                                  sx={{
                                    color: PRIMARY,
                                    fontSize: 20,
                                  }}
                                />
                              </Box>

                              <Box>
                                <Typography
                                  sx={{
                                    fontFamily: FONT,
                                    fontWeight: 700,
                                    color: TEXT,
                                    fontSize: "0.93rem",
                                  }}
                                >
                                  {assessment.title || "—"}
                                </Typography>

                                <Typography
                                  sx={{
                                    fontFamily: FONT,
                                    color: MUTED,
                                    fontSize: "0.78rem",
                                    mt: 0.3,
                                  }}
                                >
                                  {assessment.description || "Assessment"}
                                </Typography>
                              </Box>
                            </Box>
                          </TableCell>

                          <TableCell
                            sx={{
                              borderBottom: `1px solid ${BORDER}`,
                              color: MUTED,
                              fontFamily: FONT,
                              fontWeight: 500,
                              fontSize: "0.88rem",
                            }}
                          >
                            {ass.submitted_at
                              ? new Date(ass.submitted_at).toLocaleDateString(
                                  "en-US",
                                  {
                                    month: "short",
                                    day: "2-digit",
                                    year: "numeric",
                                  },
                                )
                              : "—"}
                          </TableCell>

                          <TableCell
                            sx={{
                              borderBottom: `1px solid ${BORDER}`,
                            }}
                          >
                            <Chip
                              label={`${ass.score}/${assessment.max_score}`}
                              sx={{
                                background: passed ? "#ECFDF3" : "#FEF3F2",
                                color: passed ? "#039855" : "#D92D20",
                                fontWeight: 800,
                                fontFamily: FONT,
                                borderRadius: "999px",
                              }}
                            />
                          </TableCell>

                          <TableCell
                            sx={{
                              borderBottom: `1px solid ${BORDER}`,
                            }}
                          >
                            <Button
                              onClick={() =>
                                navigate(`/ats/assessments/results/${ass.id}`)
                              }
                              sx={{
                                textTransform: "none",
                                fontFamily: FONT,
                                fontWeight: 700,
                                color: PRIMARY,
                                fontSize: "0.88rem",
                                "&:hover": {
                                  background: "transparent",
                                  textDecoration: "underline",
                                },
                              }}
                            >
                              View Detail
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default MyAssessments;
